var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Link',{staticClass:"list-header-link",attrs:{"to":_vm.to}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('i')])}
var staticRenderFns = []

export { render, staticRenderFns }